import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IDeleteServerUsersParams {
  ids: string[];
}

export interface IDeleteServerUsersResult extends IResult {
}

export class DeleteServerUsersRequest extends Request<IDeleteServerUsersParams, IDeleteServerUsersResult> {
  constructor(params: IDeleteServerUsersParams) {
    super('deleteServerUsers', params);
  }
}
